import React, { Component } from 'react';

import AppNavbar from '../Components/AppNavbar';

class Home extends Component {

    // constructor(props) {
    //     super(props);

    // }
    componentDidMount() {

    }




    render() {
        return (
            <div>
                <AppNavbar {...this.props} />
            </div>
        );
    }
}

export default Home;